import React from 'react';

/** The backend supplies the current form's field codes; users choose meaning. */
export default function NeRevenueChoice({ accountNumber, matches, value, onChange, disabled = false }) {
    return (
        <div>
            <p className="small text-muted mb-2">
                Momsfält 42 avgör inte ensamt NE-raden. Välj efter verksamheten som intäkten hör till.
            </p>
            <select
                className="form-select form-select-sm"
                aria-label={`NE-rad för konto ${accountNumber}`}
                value={value || ''}
                onChange={(event) => onChange(event.target.value)}
                disabled={disabled}
            >
                <option value="">Välj R1 eller R2…</option>
                {(matches || []).map((match) => (
                    <option key={match.faltKod} value={match.faltKod}>
                        {match.inkRow === 'R1'
                            ? 'R1 — Intäkt i momspliktig verksamhet (även export)'
                            : 'R2 — Intäkt i momsfri verksamhet (t.ex. tandvård)'}
                    </option>
                ))}
            </select>
            <p className="small text-muted mt-1 mb-0">
                Har du båda typerna av verksamhet? Stäm av fördelningen med din redovisningskonsult. Valet gäller hela kontot.
            </p>
        </div>
    );
}
